import { isNonEmptyString, isObject } from '../../../utils/checks'
import { normalizeInsuranceCard } from './normalizeInsuranceCard'
import transformTextToSlug from '../../../utils/transformTextToSlug'
import { getColorInsuranceLogo } from '../../../utils/getColorInsuranceLogo'
import { isLocationPageType } from '../pageTypeCheck'
export const getInsuranceMiniCardsFromAlgoliaResults = (
  items = [],
  itemsToIgnore = [],
  pageType = '',
  location = '',
  isUnitedStatesCount = false,
  primaryFocus
) => {
  if (!Array.isArray(items)) {
    return []
  }

  const anchorTitle =
    isNonEmptyString(primaryFocus) && primaryFocus === 'Substance Use'
      ? 'Rehabs'
      : 'Centers'

  return items
    .filter((item) => isObject(item) && Boolean(item.count))
    .filter((item) => !itemsToIgnore.includes(item.label))
    .map((item) => {
      const insuranceSlug = transformTextToSlug(item.label?.toLowerCase()) || ''
      const slug = `/${location}/${insuranceSlug}`
      return {
        img: isNonEmptyString(item?.label)
          ? getColorInsuranceLogo(insuranceSlug)
          : undefined,
        count: item.count,
        title: item.label || '',
        location,
        isUnitedStatesCount,
        slug,
        insuranceSlug,
        anchorTitle
      }
    })
    .sort((itemA, itemB) => itemB.count - itemA.count)
    .map(normalizeInsuranceCard)
}
